<template>
    <div class="info-box">
        <p class="title">{{title}}</p>
        <div class="row-box">
          <template
            v-for="(item,index) in data">
            <p
              :key="index"
              v-if="item.type === 'content'"
              class="block"
            >
              <span class="name" :style="item.style">{{item.key}}</span>
              <span class="value">{{item.value}}</span>
            </p>
            <p v-else
               :key="index"
               class="row">
               <span class="name" :style="item.style">{{item.key}}</span>
               <img class="img" v-if="item.type === 'image'" :src="item.value" alt="img" />
               <span v-else class="value">{{item.value}}</span>
            </p>
          </template>
        </div>
    </div>
</template>

<script>
export default {
  name: 'info',
  props: {
    title: String,
    data: Array
  }
}
</script>

<style lang="scss" scoped>
.info-box{
  padding: 30px 40px;
  width: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .block{
    display: flex;
    width: 100%;
    line-height: 30px;

    .name{
      width: 120px;
      font-size: 14px;
      color: #8e8e8e;
    }
  }
  .title{
    font-size: 14px;
    color: #323232;
    margin-bottom: 12px;
  }
  .row-box{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .row{
    display: flex;
    line-height: 30px;
    width: 33.33%;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .name{
      width: 80px;
      font-size: 14px;
      color: #8e8e8e;
    }
    .img{
      width: 100px;
      height: 50px;
      object-fit: contain;
    }
    .value{
      font-size: 14px;
      color: #8e8e8e;
    }
  }
}
</style>
